import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import tokens from '../theme/tokens';

/** Vitórias do jogador na pelada ao lado do nome: "2×" + troféu dourado. Não aparece com 0 vitórias. */
const TrofeusVitorias = ({ vitorias = 0, sx }) => {
  if (!vitorias) return null;
  return (
    <Stack
      component="span"
      direction="row"
      alignItems="center"
      spacing={0.25}
      title={`${vitorias} ${vitorias === 1 ? 'vitória' : 'vitórias'} hoje`}
      sx={{ flexShrink: 0, color: tokens.color.gold, fontWeight: 800, fontSize: 13, lineHeight: 1, ...sx }}
    >
      <Box component="span">{vitorias}×</Box>
      <EmojiEventsRoundedIcon sx={{ fontSize: 18 }} />
    </Stack>
  );
};

export default TrofeusVitorias;
